export default __webpack_public_path__ + "static/media/chat.01b8e065.svg";